export default __webpack_public_path__ + "static/media/newspaper.61192742.svg";